<script>
    import TrabajadorEnListado from "./Trabajador.svelte";
    import {differenceInMinutes, parse} from 'date-fns';

    export let trabajadores;

    let trabajadoresOrdenados = [];
    const ahora = new Date();

    $: {
        const listado = trabajadores.map(trabajador => {
            let diferencia = Infinity;

            if (trabajador.marcaje && trabajador.marcaje.horas.length) {
                const horas = trabajador.marcaje.horas,
                        ultimaHora = horas[horas.length - 1],
                        fecha = parse(`${trabajador.marcaje.fecha} ${ultimaHora.hora}`, 'yyyy-MM-dd HH:mm', new Date());

                diferencia = differenceInMinutes(ahora, fecha);
            }

            return {...trabajador, diferencia};
        });

        listado.sort((a, b) => a.diferencia > b.diferencia ? 1 : -1);
        trabajadoresOrdenados = listado;
    }
</script>

<style>
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    li {
        display: flex;
        justify-content: space-between;
    }

    li:not(:last-child) {
        margin-bottom: 1em;
    }
</style>

<div class="listadoDeTrabajadores">
    <div class="inner">
        <ul>
            {#each trabajadoresOrdenados as trabajador (trabajador.trabajador.id)}
                <li>
                    <TrabajadorEnListado {trabajador}/>
                </li>
            {/each}
        </ul>
    </div>
</div>